// ChatDAGRAGDAG squad types — mirror backend Pydantic in
// backend/app/schemas/squads.py + sqdr_001-005 CHECK constraints.
// Keep both sites in lockstep (per SP1-SC-06 single-source-of-truth caveat).

export type SquadStatus =
  | 'dispatching'
  | 'running'
  | 'completed'
  | 'recalled'
  | 'timed_out'
  | 'cost_capped';

export type SquadMemberStatus =
  | 'pending'
  | 'dispatched'
  | 'running'
  | 'done'
  | 'failed'
  | 'skipped'
  | 'recalled'
  | 'timed_out';

export type Stance = 'allegiant' | 'skeptical' | 'neutral';
export type Pattern = 'P1_tag_in' | 'P2_call_a_friend' | 'P3_examine_then_dag';

export interface Squad {
  id: string;
  session_id: string;
  dispatched_by_persona_id: string;
  dispatched_at: string;
  status: SquadStatus;
  completion_timeout_at: string;
  cascade_depth: number;
  source_node_ids?: string[] | null;
  fold_back_to_message_id?: string | null;
  rationale: string;
  total_estimated_cost_usd: number;
  total_actual_cost_usd: number;
  recalled_by_persona_id?: string | null;
  recalled_at?: string | null;
}

export interface SquadMember {
  id: string;
  squad_id: string;
  persona_id: string;
  task_brief: string;
  stance: Stance;
  pattern: Pattern;
  spine_root_message_id?: string | null;
  status: SquadMemberStatus;
  estimated_cost_usd: number;
  actual_cost_usd: number;
  output_summary?: string | null;
  dispatched_at?: string | null;
  completed_at?: string | null;
}

export interface SquadAuditEvent {
  id: string;
  squad_id: string;
  ts: string;
  event: string;
  actor: string;
  details: Record<string, any>;
}

// Operator-facing pattern labels — drop P1/P2/P3 from operator UI per
// cycle-2 UX F2 (insider vocab on a 2-digit IQ glance lens, per
// `feedback_2_digit_iq_glance_lens`).
export const PATTERN_LABEL: Record<Pattern, string> = {
  P1_tag_in: 'tag-in',
  P2_call_a_friend: 'call-in',
  P3_examine_then_dag: 'examine + branch',
};

// Terminal states (sticky-terminal reducer logic per cycle-2 invariant #3).
export const TERMINAL_SQUAD_STATES: ReadonlySet<SquadStatus> = new Set<SquadStatus>([
  'completed', 'recalled', 'timed_out', 'cost_capped',
]);

export const TERMINAL_MEMBER_STATES: ReadonlySet<SquadMemberStatus> = new Set<SquadMemberStatus>([
  'done', 'failed', 'skipped', 'recalled', 'timed_out',
]);
